import { Component } from '@angular/core';

@Component({
  selector: 'nft-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
}
